import { useQuery } from '@tanstack/react-query';
import { shouldShowSubscriptionRiskChip } from '@/application/metrics/subscriptionStory';
import { getBillingVsRevenue, getPlanBilling } from '@/infrastructure/http/metricsApi';
import { metricsKeys } from '@/infrastructure/query/metricsKeys';
import { useAuth } from '@/presentation/contexts/useAuth';
import { usePermissions } from '@/presentation/contexts/permissionsContextCore';

const MAX_CLINICS = 6;

export function useSubscriptionRiskChip(year: number, month: number, tenantIds: string[]) {
  const { token } = useAuth();
  const { hasPermission } = usePermissions();
  const canPlan = hasPermission('metrics.plan_billing');
  const canBurden = hasPermission('metrics.plan_recaudacion');
  const scoped = tenantIds.filter(Boolean).slice(0, MAX_CLINICS);
  const enabled = Boolean(token && scoped.length > 0 && (canPlan || canBurden));

  const query = useQuery({
    queryKey: metricsKeys.subscriptionRisk(year, month, scoped),
    queryFn: async () => {
      const rows = await Promise.all(
        scoped.map(async (tenantId) => {
          if (canBurden) {
            const vs = await getBillingVsRevenue(token!, { tenantId, year, month });
            return {
              hasRecord: vs.hasBillingRecord,
              alDia: vs.alDia,
              deudaAcumulada: vs.deudaAcumulada,
              nivel: vs.nivel,
            };
          }
          const billing = await getPlanBilling(token!, { tenantId, year, month });
          return {
            hasRecord: billing.hasRecord,
            alDia: billing.alDia,
            deudaAcumulada: billing.deudaAcumulada,
            nivel: null,
          };
        })
      );
      return shouldShowSubscriptionRiskChip(rows);
    },
    enabled,
  });

  return enabled && query.data === true;
}
